export default __webpack_public_path__ + "static/media/guide-off.8146c84e.svg";